/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_Q5Inputs */

const en_cad_faq_q5 = /** @type {(inputs: Cad_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do AI agents control CADCraft?`)
};

/**
* | output |
* | --- |
* | "How do AI agents control CADCraft?" |
*
* @param {Cad_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_q5 = /** @type {((inputs?: Cad_Faq_Q5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_Q5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_q5(inputs)
});
export { cad_faq_q5 as "cad.faq.q5" }